import { render, staticRenderFns } from "./WildTrainerFightDialog.vue?vue&type=template&id=18c02f62&scoped=true"
import script from "./WildTrainerFightDialog.vue?vue&type=script&lang=js"
export * from "./WildTrainerFightDialog.vue?vue&type=script&lang=js"
import style0 from "./WildTrainerFightDialog.vue?vue&type=style&index=0&id=18c02f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c02f62",
  null
  
)

export default component.exports